import { useNavigate } from 'react-router-dom';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import { AdvertiseLayout } from '@/components/advertise/AdvertiseLayout';
import { AdvertiseSideSummary } from '@/components/advertise/AdvertiseSideSummary';
import { AdvertiseFooterNav } from '@/components/advertise/AdvertiseFooterNav';
import { useAdvertise } from '@/store/useAdvertise';
import { AGENTS_STEPS } from '@/config/advertiseSteps';
import { ADVERTISE_AGENTS } from '@/constants/testIds/advertise';

const PLANS = [
  { id: 'membership', label: 'Agent Membership', desc: 'Ongoing premium placement across all your active listings.', testId: ADVERTISE_AGENTS.planMembership },
  { id: 'boost', label: 'Listing Boost', desc: 'One-time boost for a single active listing.', testId: ADVERTISE_AGENTS.planBoost },
  { id: 'both', label: 'Not sure — talk to sales', desc: 'We\u2019ll help you pick the right fit on your call.', testId: ADVERTISE_AGENTS.planBoth },
];

export default function AgentsPlan() {
  const navigate = useNavigate();
  const agents = useAdvertise((s) => s.agents);
  const setField = useAdvertise((s) => s.setField);

  return (
    <AdvertiseLayout
      trackLabel="Agent advertising"
      steps={AGENTS_STEPS}
      currentStepId="plan"
      title="What are you looking to do?"
      subtitle="Pick the option that best matches your goals — you can always adjust with our team."
      sidebar={<AdvertiseSideSummary items={[{ label: 'Plan', value: PLANS.find((p) => p.id === agents.plan)?.label }]} />}
      footer={
        <AdvertiseFooterNav
          showBack={false}
          nextDisabled={!agents.plan}
          onNext={() => navigate('/advertise/agents/profile')}
        />
      }
    >
      <RadioGroup value={agents.plan} onValueChange={(v) => setField('agents', { plan: v })} className="gap-3">
        {PLANS.map((p) => (
          <Label
            key={p.id}
            htmlFor={`plan-${p.id}`}
            className={cn(
              'flex cursor-pointer items-start gap-3 rounded-2xl border p-4 transition-colors',
              agents.plan === p.id ? 'border-blue-600 bg-blue-50' : 'border-slate-200 hover:border-blue-300'
            )}
          >
            <RadioGroupItem value={p.id} id={`plan-${p.id}`} className="mt-1" data-testid={p.testId} />
            <span>
              <span className="block font-semibold text-slate-900">{p.label}</span>
              <span className="block text-sm text-slate-600">{p.desc}</span>
            </span>
          </Label>
        ))}
      </RadioGroup>
    </AdvertiseLayout>
  );
}
